import React, { FC } from "react";
import { ALIGN, DISPLAY, FLEX_DIRECTION, SPACE, View } from "@lookiero/aurora";
import { Text } from "@lookiero/sty-psp-ui";

interface TotalTableLineProps {
  readonly title: string;
  readonly amount: string;
}

const TotalTableLine: FC<TotalTableLineProps> = ({ title, amount }) => (
  <View
    display={DISPLAY.FLEX}
    flexDirection={FLEX_DIRECTION.ROW}
    justifyContent={ALIGN.BETWEEN}
    marginBottom={SPACE.SPACE_4}
  >
    <Text level={3}>{title}</Text>
    <Text level={3}>{amount}</Text>
  </View>
);

export { TotalTableLine };
